export default {
	approved: "approved",
	verified: "verified",
	canceled: "canceled",
};